import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { getEvent } from '../../../../common/api/events';
import { Loading } from '../../../../components/Loading';
import { EventView } from './event';
import { BreadcrumbGroup } from '@cloudscape-design/components';

export default function View() {
  const { eventUuid } = useParams();
  const navigate = useNavigate();

  const getQuery = useQuery({
    queryKey: ['events', eventUuid],
    queryFn: () => (eventUuid ? getEvent(eventUuid) : null),
    enabled: !!eventUuid,
    staleTime: 0,
    gcTime: 0,
  });
  const event = getQuery.data;

  return (
    <div className="bg-[#101c2c] text-white font-sans p-4">
      <div className="mb-4">
        <BreadcrumbGroup
          items={[
            { text: 'Manage', href: '/manage' },
            { text: 'Events', href: '/manage/events' },
            { text: event?.name ?? '...', href: `/manage/events/${event?.eventUuid}` },
          ]}
          onFollow={(e) => {
            e.preventDefault();
            navigate(e.detail.href);
          }}
        />
      </div>
      {getQuery.isLoading || !getQuery.data || !event ? (
        <Loading />
      ) : (
        <EventView event={event} refetch={getQuery.refetch} />
      )}
    </div>
  );
}
